import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';
export default{
    state:{
        movies:[]
    },
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/modules/movies/store/index.js